import { useMemo } from "react";

import { useUser } from "@components/user-context";
import { bugsnagClient } from "@internal/analytics";
import { Currencies } from "@north-beam/nb-common";

export const useUserCurrency = () => {
  const { user } = useUser();

  const currentCurrencyCode = user.currencies.currentCurrency;

  const currentCurrencyParsed = useMemo(() => {
    const errorMessage =
      `The user's preferred currency, '${currentCurrencyCode}', does not exist in the ` +
      "'Currencies' mapping.  A formal name and value cannot be generated, but the raw value " +
      "will be shown as a placeholder.";

    return Currencies.getModelSafe(currentCurrencyCode, {
      strict: false,
      onError: () => {
        bugsnagClient.notify({
          message: errorMessage,
          name: "Configured Currency",
        });
      },
    });
  }, [currentCurrencyCode]);

  return {
    currentCurrencyCode: currentCurrencyParsed?.value ?? currentCurrencyCode,
    targetCurrencyCode: user.currencies.targetCurrency,
    currentCurrency: currentCurrencyParsed,
  };
};
